<div class="position-fixed toast-custom" [ngClass]="{'inicialized': this.ToastService._toastState}">
    <div id="mainToastConatiner" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-header" [ngClass]="{'text-danger': this.ToastService._toastType === 'error', 'text-warning': this.ToastService._toastType === 'warning'}">
            <fa-icon class="faExclamationCircle me-2" [icon]="faExclamationCircle"></fa-icon>
            <strong class="me-auto">{{ this.ToastService._toastType }}</strong>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close" (click)="this.ToastService.closeMessage()"></button>
        </div>
        <div class="toast-body">
            {{ this.ToastService._toastMessage }}
        </div>
    </div>
</div>